import { render, staticRenderFns } from "./PropertyHistory.vue?vue&type=template&id=324efc02&"
import script from "./PropertyHistory.vue?vue&type=script&lang=ts&"
export * from "./PropertyHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports